const wixHeaderAndFooterModuleName = 'header-footer-wix-statics';

const getConfig = (config, nodes) => {
  const wixSitesWithNoStickyHeader = [
    'wix.com/ascend/home',
    'wix.com/website/templates',
    'support.wix.com',
    'wix.com/domain/names',
    'wix.com/features/wix-seo'
  ];
  const isWixSite = config.hostPage === 'editor';
  config.useOnly = config.useOnly === 'header' ? 'none' : 'footer';
  const sticky = config.isWixHeader2020Sticky !== null ? config.isWixHeader2020Sticky : !wixSitesWithNoStickyHeader.some(url => window.location.href.includes(url));
  const isSupportSite = window.location.href.includes('support.wix.com');
  const newConfig = {
    sticky,
    headerWrapper: isWixSite ? null : nodes.header,
    isSupportSite,
    languageRedirectUrl: config.languageRedirectUrl,
    hideMainLinksOnDesktop: config.hideMainLinksOnDesktop,
    language: config.language,
    postLogin: config.postLogin,
    postSignUp: config.postSignUp,
  };

  if (config.languagePickerList) {
    newConfig.languagePickerList = config.languagePickerList;
  }
  return newConfig;
};

export const initWixHeader2020 = (config, nodes) => {
  const wixHeaderConfig = getConfig(config, nodes);
  if (typeof window.initHeaderAndFooter2020 === 'function') {
    window.initHeaderAndFooter2020(wixHeaderConfig);
  } else if (window[wixHeaderAndFooterModuleName]) {
    window[wixHeaderAndFooterModuleName].initHeaderAndFooter2020(wixHeaderConfig);
  } else if (typeof window.require === 'function') {
    window.require([wixHeaderAndFooterModuleName], hnf => hnf.initHeaderAndFooter2020(wixHeaderConfig));
  } else {
    config.hideHeader = false;
    console.warn('Error getting init function of Wix Header 2020');
    return;
  }
  if (config.hostPage === 'editor') {
    if (nodes.header) {
      nodes.header.remove();
      nodes.header = null;
    }
  }
};

const isExcludedSite = () => {
  const excludedSiteList = [
    'wix.com/user-journey-chat-sidebar',
    'wix.com/premium-manage-subscriptions'
  ];
  return excludedSiteList.some(url => window.location.href.includes(url));
};

export const shouldRenderWixHeader2020 = (config, experiments) => {
  if (!config) {
    return false;
  }
  const isOnlyFooter = config.useOnly === 'footer';
  const isSupportedLanguage = ['en'].includes(config.language);
  //TODO need to remove hardcoded experiment languages using new experiment api
  const isExperimentEnabled = experiments && experiments['specs.funnel.EnableWixHeaderInNew6Langs'] === 'B';
  return !isOnlyFooter && !isExcludedSite() && (isSupportedLanguage || isExperimentEnabled);
};
